import Immutable from 'immutable';
import types from './types';

const initialState = Immutable.List();

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_COUNTRIES_SUCCESS:
      // Guard against missing payload so we never return undefined (Redux forbids it).
      return action.payload != null ? Immutable.fromJS(action.payload) : state;
    default:
      return state;
  }
};

export default reducer;
